import { render } from "./PreActionNewVersion.vue?vue&type=template&id=297192ee&scoped=true"
import script from "./PreActionNewVersion.vue?vue&type=script&lang=js"
export * from "./PreActionNewVersion.vue?vue&type=script&lang=js"

import "./PreActionNewVersion.vue?vue&type=style&index=0&id=297192ee&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-297192ee"]])

export default __exports__